import React, { useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";

// Define styles
const styles = StyleSheet.create({
  page: { padding: 30, backgroundColor: "#FFFFFF" },
  header: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  subheader: {
    fontSize: 12,
    textAlign: "center",
    color: "#333",
    marginBottom: 15,
  },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#D3D3D3",
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid #D3D3D3",
    // alignItems:"center"
  },
  tableHeader: {
    backgroundColor: "#E0E0E0",
    padding: 6,
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#D3D3D3",
    width: "100%",
    height: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  tableHeader2: {
    backgroundColor: "#E0E0E0",
    padding: 6,
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#D3D3D3",
    width: "200%",
    height: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  tableHeaderdot5: {
    backgroundColor: "#E0E0E0",
    padding: 6,
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#D3D3D3",
    width: "50%",
    height: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  tableHeader2dot5: {
    backgroundColor: "#E0E0E0",
    padding: 6,
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#D3D3D3",
    width: "250%",
    height: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  tableCell: {
    padding: 6,
    fontSize: 9,
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#D3D3D3",
    width: "100%",
  },
  tableCell2: {
    padding: 6,
    fontSize: 9,
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#D3D3D3",
    width: "200%",
  },
  tableCelldot5: {
    padding: 6,
    fontSize: 9,
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#D3D3D3",
    width: "50%",
  },
  tableCell2dot5: {
    padding: 6,
    fontSize: 9,
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#D3D3D3",
    width: "250%",
  },
  tableCell6: {
    // padding: 6,
    fontSize: 9,
    textAlign: "center",
    // borderRightWidth: 1,
    // borderRightColor: '#D3D3D3',
    width: "650%",
  },
  innerRow: {
    flexDirection: "row",
  },
  tableCellEnd: { borderRightWidth: 0 },
  locationHeader: {
    fontSize: 10,
    fontWeight: "bold",
    padding: 6,
    backgroundColor: "#F5F5F5",
    borderBottomWidth: 1,
    borderBottomColor: "#D3D3D3",
    textAlign: "left",
    width: "100%",
  },
  highlightedCell: {
    padding: 6,
    fontSize: 9,
    textAlign: "center",
    color: "#000000",
  },
  positive: { backgroundColor: "#A9D08E" },
  watch: { backgroundColor: "#FFD866" },
  negative: { backgroundColor: "#F78585" },
  bold: { fontWeight: "800" },
});

// Data Example
const data2 = [
  {
    name: "Take Home",
    location: "International Landside",
    items: [
      {
        itemNo: 1,
        itemType: "Food - Cabinet",
        description: "Chicken Sandwich",
        price: "$8.50",
        comparablePrice: "$10.13",
        difference: "-$1.63",
        percentage: "-16%",
        category: "negative",
      },
      {
        itemNo: 2,
        itemType: "Food - Cabinet",
        description: "Mince Pie",
        price: "$4.70",
        comparablePrice: "$6.26",
        difference: "-$1.56",
        percentage: "-25%",
        category: "positive",
      },
      {
        itemNo: 2,
        itemType: "Food - Cabinet",
        description: "Mince Pie",
        price: "$4.70",
        comparablePrice: "$6.26",
        difference: "-$1.56",
        percentage: "-25%",
        category: "watch",
      },
      // More items can be added here...
    ],
  },
  // More locations can be added here...
];

const data = [
  {
    name: "Take Home",
    location: "International Landside",
    items: [
      {
        itemNo: 1,
        itemType: "Food - Cabinet",
        description: "Chicken Sandwich",
        price: "$8.50",
        compare: [
          {
            to: "BP, Ellerslie",
            item: "Chicken Sandwich",
            price: "$6.90",
            difference: "$1.60",
          },
          {
            to: "Wild Wheat Bakery, Mt Eden",
            item: "Chicken Sandwich",
            price: "$9.00",
            difference: "-$0.50",
          },
          {
            to: "Muffin Break, Westfield Manukau",
            item: "Chicken Sandwich",
            price: "$9.90",
            difference: "-$1.40",
          },
          {
            to: "Hollywood Bakery, Mangere",
            item: "Chicken Sandwich",
            price: "$11.50",
            difference: "-$3.00",
          },
        ],
        comparablePrice: "$10.13",
        difference: "-$1.63",
        percentage: "-16%",
        category: "negative",
      },
      {
        itemNo: 2,
        itemType: "Food - Cabinet",
        description: "Mince Pie",
        price: "$4.70",
        compare: [
          {
            to: "Z Station, Mangere",
            item: "Mince pie",
            price: "$5.20",
            difference: "-$0.50",
          },
          {
            to: "BP, Ellerslie",
            item: "Mince pie",
            price: "$5.30",
            difference: "-$0.60",
          },
          {
            to: "Airport Superette, Mangere",
            item: "Mince pie",
            price: "$5.80",
            difference: "-$1.10",
          },
          {
            to: "Massey Superette, Mangere",
            item: "Mince pie",
            price: "$5.80",
            difference: "-$1.10",
          },
        ],
        comparablePrice: "$6.26",
        difference: "-$1.56",
        percentage: "-25%",
        category: "positive",
      },
      // More items can be added here...
    ],
  },
  {
    name: "Take Home",
    location: "International Landside",
    items: [
      {
        itemNo: 1,
        itemType: "Food - Cabinet",
        description: "Chicken Sandwich",
        price: "$8.50",
        compare: [
          {
            to: "BP, Ellerslie",
            item: "Chicken Sandwich",
            price: "$6.90",
            difference: "$1.60",
          },
          {
            to: "Wild Wheat Bakery, Mt Eden",
            item: "Chicken Sandwich",
            price: "$9.00",
            difference: "-$0.50",
          },
          {
            to: "Muffin Break, Westfield Manukau",
            item: "Chicken Sandwich",
            price: "$9.90",
            difference: "-$1.40",
          },
          {
            to: "Hollywood Bakery, Mangere",
            item: "Chicken Sandwich",
            price: "$11.50",
            difference: "-$3.00",
          },
        ],
        comparablePrice: "$10.13",
        difference: "-$1.63",
        percentage: "-16%",
        category: "negative",
      },
      {
        itemNo: 2,
        itemType: "Food - Cabinet",
        description: "Mince Pie",
        price: "$4.70",
        compare: [
          {
            to: "Z Station, Mangere",
            item: "Mince pie",
            price: "$5.20",
            difference: "-$0.50",
          },
          {
            to: "BP, Ellerslie",
            item: "Mince pie",
            price: "$5.30",
            difference: "-$0.60",
          },
          {
            to: "Airport Superette, Mangere",
            item: "Mince pie",
            price: "$5.80",
            difference: "-$1.10",
          },
          {
            to: "Massey Superette, Mangere",
            item: "Mince pie",
            price: "$5.80",
            difference: "-$1.10",
          },
        ],
        comparablePrice: "$6.26",
        difference: "-$1.56",
        percentage: "-25%",
        category: "positive",
      },
      // More items can be added here...
    ],
  },
  // More locations can be added here...
];

const dfHeading = [
  "Product No.",
  "Type",
  "Product name",
  "Price",
  "Comparable Average",
  "Difference",
  "Percentage Difference",
];
const fnbHeading = [
  "Item No.",
  "Item Type",
  "Item Description",
  "Price",
  "Comparision Average",
  "Difference",
  "Percentage Difference",
];

// Create PDF component

const getPage = (location, section, heading, reportDate) => (
  <Page style={styles.page} size="A4" orientation="landscape">
    <View style={styles.header}>
      <Text style={styles.main}>
        AIA {section === "fnb" ? "Food Beverage" : "Duty Free"} Price Check
      </Text>
      <Text style={styles.sub}>
        {reportDate}
      </Text>
    </View>
    {/* Header */}

    {/* Table */}
    <View style={styles.table}>
      {/* Table Header */}

      {/* Table Rows */}

      {/* Location Header Row */}
      <View style={styles.tableRow}>
        <Text style={styles.locationHeader}>
          {location.name} - {location.location}
        </Text>
      </View>
      <View style={styles.tableRow}>
        {heading.map((header, index) => (
          <Text
            key={index}
            style={[styles.tableHeader, index === 8 && styles.tableCellEnd]}
          >
            {header}
          </Text>
        ))}
      </View>
      {location.items.map((item, itemIndex) => (
        <View style={styles.tableRow} key={itemIndex}>
          <Text style={styles.tableCell}>{item.itemNo}</Text>
          <Text style={styles.tableCell}>{item.itemType}</Text>
          <Text style={styles.tableCell}>{item.description}</Text>
          <Text style={styles.tableCell}>{item.price}</Text>
          <Text style={styles.tableCell}>{item.comparablePrice}</Text>
          <Text style={styles.tableCell}>{item.difference}</Text>
          <Text
            style={[
              styles.tableCell,
              item.category === "positive" && styles.positive,
              item.category === "watch" && styles.watch,
              item.category === "negative" && styles.negative,
              styles.highlightedCell,
            ]}
          >
            {item.percentage}
          </Text>
        </View>
      ))}
    </View>
  </Page>
);

const getComparePage = (location, section, heading, reportDate) => (
  <Page style={styles.page} size="A4" orientation="landscape">
    <View style={styles.header}>
      <Text style={styles.main}>
        AIA {section === "fnb" ? "Food Beverage" : "Duty Free"} Price Check
      </Text>
      <Text style={styles.sub}>
        {" "}
        {reportDate}
      </Text>
    </View>
    {/* Header */}

    {/* Table */}
    <View style={styles.table}>
      {/* Table Header */}

      {/* Table Rows */}
      {/* Location Header Row */}
      <View style={styles.tableRow}>
        <Text style={styles.locationHeader}>
          {location.name} - {location.location}
        </Text>
      </View>
      <View style={styles.tableRow}>
        {heading.slice(0, 3).map((header, index) => (
          <Text
            key={index}
            style={[styles.tableHeader, index === 8 && styles.tableCellEnd]}
          >
            {header}
          </Text>
        ))}
        <Text
          key={3}
          style={[
            {
              ...styles.tableHeaderdot5,
              width: section === "df" ? "60%" : "50%",
            },
          ]}
        >
          Price
        </Text>
        <Text key={4} style={[styles.tableHeader2dot5]}>
          Compare To
        </Text>
        {[`Comparison ${section === "fnb" ? "Item" : "product"}`].map(
          (header, index) => (
            <Text key={index + 5} style={[styles.tableHeader2]}>
              {header}
            </Text>
          )
        )}
        {[
          "Comparison Indicative Pricing",
          "Indicative Difference",
          "Difference as percentage of comparable price",
        ].map((header, index) => (
          <Text
            key={index}
            style={[styles.tableHeader, index === 8 && styles.tableCellEnd]}
          >
            {header}
          </Text>
        ))}
      </View>
      {location.items.map((item, itemIndex) => (
        <View style={styles.tableRow} key={itemIndex}>
          <Text style={styles.tableCell}>{item.itemNo}</Text>
          <Text style={styles.tableCell}>{item.itemType}</Text>
          <Text style={styles.tableCell}>{item.description}</Text>
          <Text style={styles.tableCelldot5}>{item.price}</Text>
          <View style={styles.tableCell6}>
            {item.compare.map((cmp, idx) => {
              let displayTo = cmp.to;
              if (displayTo && displayTo.toLowerCase().startsWith('auckland-auckland')) {
                displayTo = 'Auckland Dutyfree';
              }
              
              return (
                <View style={styles.innerRow} key={idx}>
                  <Text style={styles.tableCell2dot5}>
                    {section === "fnb" && cmp.terminal 
                      ? `${displayTo} (${cmp.terminal})` 
                      : displayTo}
                  </Text>
                  <Text style={styles.tableCell2}>{cmp.item}</Text>
                  <Text style={styles.tableCell}>{cmp.price}</Text>
                  <Text style={styles.tableCell}>{cmp.difference}</Text>
                </View>
              );
            })}
            <View style={styles.innerRow}>
              <Text style={styles.tableCell2dot5}>{""}</Text>
              <Text style={[styles.tableCell2, styles.bold]}>
                {"Comparision Average"}
              </Text>
              <Text style={styles.tableCell}>{item.comparablePrice}</Text>
              <Text style={styles.tableCell}>{item.difference}</Text>
            </View>
          </View>
          <Text
            style={[
              styles.tableCell,
              item.category === "positive" && styles.positive,
              item.category === "watch" && styles.watch,
              item.category === "negative" && styles.negative,
              styles.highlightedCell,
            ]}
          >
            {item.percentage}
          </Text>
        </View>
      ))}
    </View>
  </Page>
);
const PdfDocument = ({ data, section, reportDate }) => {
  const [heading] = useState(section === "fnb" ? fnbHeading : dfHeading);

  // Only render locations with items
  const filteredData = data.filter(location => location.items && location.items.length > 0);

  // Use provided reportDate or fallback to current date
  const displayDate = reportDate || new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
  });

  return (
    <Document>
      {filteredData.map((location) => getPage(location, section, heading, displayDate))}
      {filteredData.map((location) => getComparePage(location, section, heading, displayDate))}
    </Document>
  );
};

export default PdfDocument;
